<div class="row">
  <div class="col-8">
    <h3 style="text-align: right;">Customer Card Preview</h3>
  </div>
  <div class="col" style="text-align: right;">
    <button mat-raised-button (click)="closeComponent()" style="color: white; background: red;">CLOSE</button>
  </div>
</div><br>
<div class="row">
  <div class="col">
    <iframe *ngIf="is_new_layout_selected" [src]="new_layout_data['pdf']" style="height: 600px; width: 100%;"></iframe>
    <iframe *ngIf="!is_new_layout_selected" [src]="old_layout_data['pdf']" style="height: 600px; width: 100%;"></iframe>
  </div>
</div>
<footer>
  <div class="row">
    <div class="col">
      <button (click)="reportChangeOptionCliked()" mat-raised-button
        style="color: white; background: greenyellow;">{{current_report_option}}</button>
    </div>
    <div class="col"></div>
  </div>
</footer>
